import type { Language, Translations } from '../types';

export const translations: Translations = {
  // App Title
  'app.title': {
    en: 'THE FIVE: PRAYER TRACKER',
    ar: 'الخمسة: متتبع الصلاة',
    id: 'THE FIVE: PELACAK SHOLAT',
    ms: 'THE FIVE: PENJEJAK SOLAT',
    tr: 'THE FIVE: NAMAZ TAKİPÇİSİ',
    ur: 'THE FIVE: نماز ٹریکر',
    fa: 'THE FIVE: ردیاب نماز',
    bn: 'THE FIVE: নামাজ ট্র্যাকার',
    hi: 'THE FIVE: नमाज़ ट्रैकर',
    fr: 'THE FIVE: SUIVI DES PRIÈRES',
    es: 'THE FIVE: SEGUIDOR DE ORACIONES',
    de: 'THE FIVE: GEBETS-TRACKER',
    ru: 'THE FIVE: ТРЕКЕР МОЛИТВ',
    zh: 'THE FIVE: 祈祷追踪器'
  },

  // Save functionality
  'save.unsavedChanges': {
    en: 'You have unsaved changes',
    ar: 'لديك تغييرات غير محفوظة',
    id: 'Anda memiliki perubahan yang belum disimpan',
    ms: 'Anda mempunyai perubahan yang belum disimpan',
    tr: 'Kaydedilmemiş değişiklikleriniz var',
    ur: 'آپ کے پاس غیر محفوظ تبدیلیاں ہیں',
    fa: 'تغییرات ذخیره نشده دارید',
    bn: 'আপনার অসংরক্ষিত পরিবর্তন রয়েছে',
    hi: 'आपके पास असहेजे गए परिवर्तन हैं',
    fr: 'Vous avez des modifications non sauvegardées',
    es: 'Tienes cambios sin guardar',
    de: 'Sie haben ungespeicherte Änderungen',
    ru: 'У вас есть несохраненные изменения',
    zh: '您有未保存的更改'
  },
  'save.saveChanges': {
    en: 'Save Changes',
    ar: 'حفظ التغييرات',
    id: 'Simpan Perubahan',
    ms: 'Simpan Perubahan',
    tr: 'Değişiklikleri Kaydet',
    ur: 'تبدیلیاں محفوظ کریں',
    fa: 'ذخیره تغییرات',
    bn: 'পরিবর্তন সংরক্ষণ করুন',
    hi: 'परिवर्तन सहेजें',
    fr: 'Sauvegarder les Modifications',
    es: 'Guardar Cambios',
    de: 'Änderungen Speichern',
    ru: 'Сохранить Изменения',
    zh: '保存更改'
  },
  'save.saving': {
    en: 'Saving...',
    ar: 'جاري الحفظ...',
    id: 'Menyimpan...',
    ms: 'Menyimpan...',
    tr: 'Kaydediliyor...',
    ur: 'محفوظ کر رہے ہیں...',
    fa: 'در حال ذخیره...',
    bn: 'সংরক্ষণ করা হচ্ছে...',
    hi: 'सहेजा जा रहा है...',
    fr: 'Sauvegarde...',
    es: 'Guardando...',
    de: 'Speichern...',
    ru: 'Сохранение...',
    zh: '保存中...'
  },

  // Date Navigation
  'date.today': {
    en: 'Today',
    ar: 'اليوم',
    id: 'Hari Ini',
    ms: 'Hari Ini',
    tr: 'Bugün',
    ur: 'آج',
    fa: 'امروز',
    bn: 'আজ',
    hi: 'आज',
    fr: 'Aujourd\'hui',
    es: 'Hoy',
    de: 'Heute',
    ru: 'Сегодня',
    zh: '今天'
  },
  'date.goToToday': {
    en: 'Go to Today',
    ar: 'اذهب إلى اليوم',
    id: 'Ke Hari Ini',
    ms: 'Pergi ke Hari Ini',
    tr: 'Bugüne Git',
    ur: 'آج جائیں',
    fa: 'برو به امروز',
    bn: 'আজকে যান',
    hi: 'आज जाएं',
    fr: 'Aller à Aujourd\'hui',
    es: 'Ir a Hoy',
    de: 'Zu Heute Gehen',
    ru: 'Перейти к Сегодня',
    zh: '转到今天'
  },

  // Prayer Titles
  'prayers.todayTitle': {
    en: 'Today\'s Prayers',
    ar: 'صلوات اليوم',
    id: 'Sholat Hari Ini',
    ms: 'Solat Hari Ini',
    tr: 'Bugünün Namazları',
    ur: 'آج کی نمازیں',
    fa: 'نمازهای امروز',
    bn: 'আজকের নামাজ',
    hi: 'आज की नमाज़ें',
    fr: 'Prières d\'Aujourd\'hui',
    es: 'Oraciones de Hoy',
    de: 'Heutige Gebete',
    ru: 'Сегодняшние Молитвы',
    zh: '今天的祈祷'
  },
  'prayers.prayersFor': {
    en: 'Prayers for',
    ar: 'صلوات',
    id: 'Sholat untuk',
    ms: 'Solat untuk',
    tr: 'Namazları',
    ur: 'نمازیں',
    fa: 'نمازهای',
    bn: 'নামাজ',
    hi: 'नमाज़ें',
    fr: 'Prières pour',
    es: 'Oraciones para',
    de: 'Gebete für',
    ru: 'Молитвы за',
    zh: '祈祷为'
  },
  // Statistics
  'stats.todayProgress': {
    en: 'Today\'s Progress',
    ar: 'تقدم اليوم',
    id: 'Kemajuan Hari Ini',
    ms: 'Kemajuan Hari Ini',
    tr: 'Bugünün İlerlemesi',
    ur: 'آج کی پیش قدمی',
    fa: 'پیشرفت امروز',
    bn: 'আজকের অগ্রগতি',
    hi: 'आज की प्रगति',
    fr: 'Progrès d\'Aujourd\'hui',
    es: 'Progreso de Hoy',
    de: 'Heutiger Fortschritt',
    ru: 'Сегодняшний Прогресс',
    zh: '今天的进展'
  },
  'stats.progressFor': {
    en: 'Progress for',
    ar: 'التقدم لـ',
    id: 'Kemajuan untuk',
    ms: 'Kemajuan untuk',
    tr: 'İlerleme',
    ur: 'پیش قدمی',
    fa: 'پیشرفت برای',
    bn: 'অগ্রগতি',
    hi: 'प्रगति',
    fr: 'Progrès pour',
    es: 'Progreso para',
    de: 'Fortschritt für',
    ru: 'Прогресс за',
    zh: '进展为'
  },
  'stats.weeklyAverage': {
    en: 'Weekly Average',
    ar: 'المتوسط الأسبوعي',
    id: 'Rata-rata Mingguan',
    ms: 'Purata Mingguan',
    tr: 'Haftalık Ortalama',
    ur: 'ہفتہ وار اوسط',
    fa: 'میانگین هفتگی',
    bn: 'সাপ্তাহিক গড়',
    hi: 'साप्ताहिक औसत',
    fr: 'Moyenne Hebdomadaire',
    es: 'Promedio Semanal',
    de: 'Wöchentlicher Durchschnitt',
    ru: 'Недельное Среднее',
    zh: '周平均'
  },
  'stats.monthlyAverage': {
    en: 'Monthly Average',
    ar: 'المتوسط الشهري',
    id: 'Rata-rata Bulanan',
    ms: 'Purata Bulanan',
    tr: 'Aylık Ortalama',
    ur: 'ماہانہ اوسط',
    fa: 'میانگین ماهانه',
    bn: 'মাসিক গড়',
    hi: 'मासिक औसत',
    fr: 'Moyenne Mensuelle',
    es: 'Promedio Mensual',
    de: 'Monatlicher Durchschnitt',
    ru: 'Месячное Среднее',
    zh: '月平均'
  },

  // Authentication
  'auth.signOut': {
    en: 'Sign Out',
    ar: 'تسجيل الخروج',
    id: 'Keluar',
    ms: 'Log keluar',
    tr: 'Çıkış Yap',
    ur: 'سائن آؤٹ',
    fa: 'خروج',
    bn: 'সাইন আউট',
    hi: 'साइन आउट',
    fr: 'Se déconnecter',
    es: 'Cerrar sesión',
    de: 'Abmelden',
    ru: 'Выйти',
    zh: '退出登录'
  },

  // Sync Status
  'sync.syncing': {
    en: 'Syncing...',
    ar: 'جاري المزامنة...',
    id: 'Menyinkronkan...',
    ms: 'Menyegerakkan...',
    tr: 'Senkronize ediliyor...',
    ur: 'ہم آہنگ کر رہے ہیں...',
    fa: 'در حال همگام‌سازی...',
    bn: 'সিঙ্ক করা হচ্ছে...',
    hi: 'सिंक हो रहा है...',
    fr: 'Synchronisation...',
    es: 'Sincronizando...',
    de: 'Synchronisierung...',
    ru: 'Синхронизация...',
    zh: '同步中...'
  },
  'sync.online': {
    en: 'Online',
    ar: 'متصل',
    id: 'Online',
    ms: 'Dalam talian',
    tr: 'Çevrimiçi',
    ur: 'آن لائن',
    fa: 'آنلاین',
    bn: 'অনলাইন',
    hi: 'ऑनलाइन',
    fr: 'En ligne',
    es: 'En línea',
    de: 'Online',
    ru: 'Онлайн',
    zh: '在线'
  },
  'sync.offline': {
    en: 'Offline',
    ar: 'غير متصل',
    id: 'Offline',
    ms: 'Luar talian',
    tr: 'Çevrimdışı',
    ur: 'آف لائن',
    fa: 'آفلاین',
    bn: 'অফলাইন',
    hi: 'ऑफलाइन',
    fr: 'Hors ligne',
    es: 'Sin conexión',
    de: 'Offline',
    ru: 'Офлайн',
    zh: '离线'
  },
  'sync.lastSync': {
    en: 'Last sync',
    ar: 'آخر مزامنة',
    id: 'Sinkronisasi terakhir',
    ms: 'Segerak terakhir',
    tr: 'Son senkronizasyon',
    ur: 'آخری ہم آہنگی',
    fa: 'آخرین همگام‌سازی',
    bn: 'শেষ সিঙ্ক',
    hi: 'अंतिम सिंक',
    fr: 'Dernière sync',
    es: 'Última sincronización',
    de: 'Letzte Synchronisation',
    ru: 'Последняя синхронизация',
    zh: '最后同步'
  },

  // Prayer Names
  'prayer.fajr': {
    en: 'Fajr',
    ar: 'الفجر',
    id: 'Subuh',
    ms: 'Subuh',
    tr: 'Sabah',
    ur: 'فجر',
    fa: 'صبح',
    bn: 'ফজর',
    hi: 'फज्र',
    fr: 'Fajr',
    es: 'Fajr',
    de: 'Fajr',
    ru: 'Фаджр',
    zh: '晨礼'
  },
  'prayer.dhuhr': {
    en: 'Dhuhr',
    ar: 'الظهر',
    id: 'Dzuhur',
    ms: 'Zuhur',
    tr: 'Öğle',
    ur: 'ظہر',
    fa: 'ظهر',
    bn: 'যুহর',
    hi: 'ज़ुहर',
    fr: 'Dhuhr',
    es: 'Dhuhr',
    de: 'Dhuhr',
    ru: 'Зухр',
    zh: '晌礼'
  },
  'prayer.asr': {
    en: 'Asr',
    ar: 'العصر',
    id: 'Ashar',
    ms: 'Asar',
    tr: 'İkindi',
    ur: 'عصر',
    fa: 'عصر',
    bn: 'আসর',
    hi: 'अस्र',
    fr: 'Asr',
    es: 'Asr',
    de: 'Asr',
    ru: 'Аср',
    zh: '晡礼'
  },
  'prayer.maghrib': {
    en: 'Maghrib',
    ar: 'المغرب',
    id: 'Maghrib',
    ms: 'Maghrib',
    tr: 'Akşam',
    ur: 'مغرب',
    fa: 'مغرب',
    bn: 'মাগরিব',
    hi: 'मग़रिब',
    fr: 'Maghrib',
    es: 'Maghrib',
    de: 'Maghrib',
    ru: 'Магриб',
    zh: '昏礼'
  },
  'prayer.isha': {
    en: 'Isha',
    ar: 'العشاء',
    id: 'Isya',
    ms: 'Isyak',
    tr: 'Yatsı',
    ur: 'عشاء',
    fa: 'عشا',
    bn: 'ইশা',
    hi: 'इशा',
    fr: 'Isha',
    es: 'Isha',
    de: 'Isha',
    ru: 'Иша',
    zh: '宵礼'
  },

  // Common UI Elements
  'ui.scheduled': {
    en: 'Scheduled',
    ar: 'المجدولة',
    id: 'Terjadwal',
    ms: 'Dijadualkan',
    tr: 'Planlanmış',
    ur: 'مقررہ',
    fa: 'برنامه‌ریزی شده',
    bn: 'নির্ধারিত',
    hi: 'निर्धारित',
    fr: 'Programmé',
    es: 'Programado',
    de: 'Geplant',
    ru: 'Запланировано',
    zh: '预定'
  },
  'ui.actual': {
    en: 'Actual',
    ar: 'الفعلية',
    id: 'Aktual',
    ms: 'Sebenar',
    tr: 'Gerçek',
    ur: 'حقیقی',
    fa: 'واقعی',
    bn: 'প্রকৃত',
    hi: 'वास्तविक',
    fr: 'Réel',
    es: 'Real',
    de: 'Tatsächlich',
    ru: 'Фактическое',
    zh: '实际'
  },
  'ui.location': {
    en: 'Location',
    ar: 'الموقع',
    id: 'Lokasi',
    ms: 'Lokasi',
    tr: 'Konum',
    ur: 'مقام',
    fa: 'مکان',
    bn: 'অবস্থান',
    hi: 'स्थान',
    fr: 'Emplacement',
    es: 'Ubicación',
    de: 'Standort',
    ru: 'Местоположение',
    zh: '位置'
  },

  // Prayer Details
  'prayer.details.show': {
    en: 'Show Prayer Details',
    ar: 'إظهار تفاصيل الصلاة',
    id: 'Tampilkan Detail Sholat',
    ms: 'Tunjukkan Butiran Solat',
    tr: 'Namaz Detaylarını Göster',
    ur: 'نماز کی تفصیلات دکھائیں',
    fa: 'نمایش جزئیات نماز',
    bn: 'নামাজের বিস্তারিত দেখান',
    hi: 'नमाज़ का विवरण दिखाएं',
    fr: 'Afficher les Détails de la Prière',
    es: 'Mostrar Detalles de la Oración',
    de: 'Gebetsdetails Anzeigen',
    ru: 'Показать Детали Молитвы',
    zh: '显示祈祷详情'
  },
  'prayer.details.hide': {
    en: 'Hide Details',
    ar: 'إخفاء التفاصيل',
    id: 'Sembunyikan Detail',
    ms: 'Sembunyikan Butiran',
    tr: 'Detayları Gizle',
    ur: 'تفصیلات چھپائیں',
    fa: 'پنهان کردن جزئیات',
    bn: 'বিস্তারিত লুকান',
    hi: 'विवरण छुपाएं',
    fr: 'Masquer les Détails',
    es: 'Ocultar Detalles',
    de: 'Details Ausblenden',
    ru: 'Скрыть Детали',
    zh: '隐藏详情'
  },

  // Prayer Status
  'prayer.status.jamaah': {
    en: 'Congregation',
    ar: 'جماعة',
    id: 'Berjamaah',
    ms: 'Berjemaah',
    tr: 'Cemaat',
    ur: 'جماعت',
    fa: 'جماعت',
    bn: 'জামাত',
    hi: 'जमात',
    fr: 'Congrégation',
    es: 'Congregación',
    de: 'Gemeinde',
    ru: 'Джамаат',
    zh: '集体'
  },
  'prayer.status.individual': {
    en: 'Individual',
    ar: 'فردي',
    id: 'Sendirian',
    ms: 'Bersendirian',
    tr: 'Bireysel',
    ur: 'انفرادی',
    fa: 'انفرادی',
    bn: 'একা',
    hi: 'व्यक्तिगत',
    fr: 'Individuel',
    es: 'Individual',
    de: 'Einzeln',
    ru: 'Индивидуально',
    zh: '个人'
  },

  // Location Settings
  'location.title': {
    en: 'Location Settings',
    ar: 'إعدادات الموقع',
    id: 'Pengaturan Lokasi',
    ms: 'Tetapan Lokasi',
    tr: 'Konum Ayarları',
    ur: 'مقام کی ترتیبات',
    fa: 'تنظیمات مکان',
    bn: 'অবস্থান সেটিংস',
    hi: 'स्थान सेटिंग्स',
    fr: 'Paramètres de Localisation',
    es: 'Configuración de Ubicación',
    de: 'Standort-Einstellungen',
    ru: 'Настройки Местоположения',
    zh: '位置设置'
  },
  'location.current': {
    en: 'Current Location',
    ar: 'الموقع الحالي',
    id: 'Lokasi Saat Ini',
    ms: 'Lokasi Semasa',
    tr: 'Mevcut Konum',
    ur: 'موجودہ مقام',
    fa: 'مکان فعلی',
    bn: 'বর্তমান অবস্থান',
    hi: 'वर्तमान स्थान',
    fr: 'Emplacement Actuel',
    es: 'Ubicación Actual',
    de: 'Aktueller Standort',
    ru: 'Текущее Местоположение',
    zh: '当前位置'
  },
  'location.update': {
    en: 'Update Location',
    ar: 'تحديث الموقع',
    id: 'Perbarui Lokasi',
    ms: 'Kemas Kini Lokasi',
    tr: 'Konumu Güncelle',
    ur: 'مقام اپ ڈیٹ کریں',
    fa: 'به‌روزرسانی مکان',
    bn: 'অবস্থান আপডেট করুন',
    hi: 'स्थान अपडेट करें',
    fr: 'Mettre à Jour la Localisation',
    es: 'Actualizar Ubicación',
    de: 'Standort Aktualisieren',
    ru: 'Обновить Местоположение',
    zh: '更新位置'
  },
  'location.getting': {
    en: 'Getting Location...',
    ar: 'جاري الحصول على الموقع...',
    id: 'Mendapatkan Lokasi...',
    ms: 'Mendapatkan Lokasi...',
    tr: 'Konum Alınıyor...',
    ur: 'مقام حاصل کر رہے ہیں...',
    fa: 'در حال دریافت مکان...',
    bn: 'অবস্থান পাওয়া হচ্ছে...',
    hi: 'स्थान प्राप्त कर रहे हैं...',
    fr: 'Obtention de la Localisation...',
    es: 'Obteniendo Ubicación...',
    de: 'Standort Wird Ermittelt...',
    ru: 'Получение Местоположения...',
    zh: '正在获取位置...'
  }
};

export const languageNames: { [key in Language]: string } = {
  en: 'English',
  ar: 'العربية',
  id: 'Bahasa Indonesia',
  ms: 'Bahasa Melayu',
  tr: 'Türkçe',
  ur: 'اردو',
  fa: 'فارسی',
  bn: 'বাংলা',
  hi: 'हिन्दी',
  fr: 'Français',
  es: 'Español',
  de: 'Deutsch',
  ru: 'Русский',
  zh: '中文'
};

export function getTranslation(key: string, language: Language): string {
  return translations[key]?.[language] || translations[key]?.en || key;
}